import { Alert } from "@material-ui/lab";
import { create } from "lodash";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import GovGrButton from "../../../../components/GovGrButton";
import { SECONDARY } from "../../../../components/GovGrButton/buttonConstants";
import GovGrModal from "../../../../components/GovGrModal";
import { eParavoloAVathmias, eParavoloBVathmias } from "../../../../constants";
import useLocale from "../../../../hooks/useLocale";
import { createYourParavolo } from "../../../../services/eParavolo";
import {
  eParavoloCreateButtonDisabledStatus,
  errorMessageParse,
} from "../../../../utils/errorMessage";
import CustomAlert from "../../../components/CustomAlert";
import CreateDialog from "./CreateDialog";
import SubmitDialog from "./SubmitDialog";

const rfCodeFromApplication = (data) => {
  if (data?.status === eParavoloBVathmias) {
    return {
      rfCode: data?.paravolo_rf_code_b,
      paravoloCode: data?.paravolo_payment_code_b,
    };
  }

  if (data?.status === eParavoloAVathmias) {
    return {
      rfCode: data?.paravolo_rf_code_a,
      paravoloCode: data?.paravolo_payment_code_a,
    };
  }

  return null;
};
const Eparavolo = ({ data, refetchUserApplicationData }) => {
  const { t } = useLocale();
  const [submitDialog, setSubmitDialog] = useState(false);
  const [paravolo, setParavolo] = useState(rfCodeFromApplication(data));
  const [error, setError] = useState("");

  useEffect(() => {
    setParavolo(rfCodeFromApplication(data));
  }, [data]);

  const userData = {
    application_id: data?.id,
    application_status_id: data?.status,
    port_auth_id: data?.port_authority_id,
    afm: data?.afm_afora,
    firstName: data?.fname_afora,
    lastName: data?.lname_afora,
    fatherName: data?.fath_fname_afora,
    motherName: data?.moth_fname_afora,
    emailAddress: data?.email_afora,
    mobilePhone: data?.mobile_afora,
    birthDate: data?.dt_birth_afora,
  };

  const submitData = {
    application_id: data?.id,
    application_status_id: data?.status,
  };

  const { mutate } = useMutation(createYourParavolo, {
    onSuccess: (data) => {
      setParavolo({
        rfCode: data?.data?.paravolo_rf_code,
        paravoloCode: data?.data?.paravolo_payment_code,
      });
    },
    onError: (error) => {
      setError(errorMessageParse(error.response.status));
    },
  });

  const createParavolo = () => {
    mutate(userData);
  };

  return (
    <>
      {data?.status === eParavoloAVathmias ||
      data?.status === eParavoloBVathmias ? (
        <>
          <div className="flex flex-col items-center gap-16">
            <p className="text-xl">{t("eParavoloUseorCreate")}</p>

            <CustomAlert
              open={!!error}
              close={() => {
                setError("");
              }}
              message={t(`${error}`)}
            />

            {Object.values(paravolo).filter((item) => item !== null).length >
              0 && (
              <div className="flex flex-col gap-4">
                <p className="text-lg text-success font-bold">
                  {t("eParavoloCreated")} : {paravolo.rfCode}
                </p>

                <p className="text-lg text-success font-bold">
                  {t("eParavoloPaymentCreated")} : {paravolo.paravoloCode}
                </p>
              </div>
            )}
          </div>
          <div className="h-[20vh] w-full flex flex-col gap-4 md:flex-row md:gap-8 items-center justify-center">
            <GovGrButton
              buttonText={"1. " + t("Create eParavolo")}
              variant={SECONDARY}
              onClick={createParavolo}
              disabled={eParavoloCreateButtonDisabledStatus(data)}
            />
            <GovGrButton
              buttonText={"2. " + t("Submit eParavolo")}
              variant={SECONDARY}
              onClick={() => setSubmitDialog(true)}
            />
          </div>

          <GovGrModal open={submitDialog} customContent={true}>
            <SubmitDialog
              close={() => setSubmitDialog(false)}
              submitData={submitData}
              paravolo={paravolo}
              data={data}
              refetchUserApplicationData={refetchUserApplicationData}
            />
          </GovGrModal>
        </>
      ) : (
        <Alert severity="error" style={{ marginBottom: "1rem" }}>
          {t("Application_not_status_eParavolo")}
        </Alert>
      )}
    </>
  );
};

export default Eparavolo;
